import { Injectable } from '@angular/core';
import { ContactSubscription, ContactSubscriptionPost } from '../model/user.model';
import { ApiService } from './api.service';
import { BehaviorSubject, Subject } from 'rxjs';
import * as convertKeys from 'convert-keys';

@Injectable()
export class ContactService {
  public loading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public contact$: BehaviorSubject<any> = new BehaviorSubject({ contacts: [], contactId: null });
  constructor(private apiService: ApiService) {}

  async getContact(contactId: string) {
    try {
      this.loading$.next(true);
      const response = await this.apiService.get(`contacts/${contactId}`);
      this.contact$.next({ contacts: convertKeys.toCamel<[]>(response), contactId });
    } catch (err) {
      console.log('Could not retrieve contacts', err);
      this.contact$.next({ contacts: [], contactId });
      throw err;
    } finally {
      this.loading$.next(false);
    }
  }
}
